import { graphql, useFragment } from 'react-relay';
import { useRedemptionOptionItemQuery_optionRef$key } from './__generated__/useRedemptionOptionItemQuery_optionRef.graphql';

const fragment = graphql`
  fragment useRedemptionOptionItemQuery_optionRef on RedemptionOptionData {
    imageUrl
    key
    name
  }
`;

export function useRedemptionOptionItemQuery(
  optionRef: useRedemptionOptionItemQuery_optionRef$key,
) {
  return useFragment<useRedemptionOptionItemQuery_optionRef$key>(fragment, optionRef);
}
